import { useState } from "react";

const DemoTradingAccountContentFour = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Is the demo account completely free?",
      text: "Yes, practice at no cost with unlimited virtual funds.",
    },
    {
      title: "Does the demo use real-time market data?",
      text: "Absolutely. The pricing and conditions mirror live trading.",
    },
    {
      title: "Can I reset or top up my demo balance?",
      text: "Yes, virtual funds can be replenished anytime.",
    },
    {
      title: "How long can I use the demo?",
      text: "As long as you need. There’s no expiry.",
    },
    // {
    //   title: "Can I switch from demo to live instantly?",
    //   text: "Yes, you can upgrade to a real account with one click.",
    // },
    // {
    //   title: "Are all instruments available in the demo?",
    //   text: "Yes, Forex, commodities, crypto, indices, and more.",
    // },
    // {
    //   title: "Can I practice with different tiers?",
    //   text: "Yes, simulate any account tier from Basic to Exclusive.",
    // },
  ];

  return (
    <div className="how__work__trading">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE IMAGE + TEXT */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Demo Account FAQs</h2>
            </div>
            <div className="thumb-left">
              <img
                src={process.env.PUBLIC_URL + "/images/trading/demo_trading_account/demo_acc_6.png"}
                alt="computer images"
              />
            </div>
          </div>

          {/* RIGHT SIDE ACCORDION */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <hr className="black-line" />
              {sections.map((section, index) => (
                <div key={index} className="accordion-section">
                  <button
                    className="accordion-header"
                    onClick={() => toggleSection(index)}
                  >
                    <h3>{section.title}</h3>
                    <span
                      className={`arrow ${openIndex === index ? "open" : ""}`}
                    >
                      ▼
                    </span>
                  </button>

                  <div
                    className={`accordion-content ${
                      openIndex === index ? "show" : ""
                    }`}
                  >
                    <p>{section.text}</p>
                  </div>

                  <hr className="black-line" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoTradingAccountContentFour;
